(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[360],{

/***/ 360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4545);
/* harmony import */ var _styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2__);



//import { isMobile } from 'react-device-detect';

var Select = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(params, ref) {
    var title = params.title, placeholder = params.placeholder, options = params.options, selected = params.selected, multiple = params.multiple, search = params.search, visibility = params.visibility, style = params.style, onChange = params.onChange, onClose = params.onClose;
    // console.log(options);
    // console.log(selected);
    // console.log(visibility);
    var isMobile = false;
    /** STATES */ var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOpen = _$ref[0], setIsOpen = _$ref[1];
    var _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(Array.isArray(selected) ? selected.map(function(v) {
        return v.toString();
    }) : [
        selected.toString()
    ]), values = _$ref1[0], setValues = _$ref1[1];
    var _$ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
        var finalArray = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (item.type === "optgroup") {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        // eslint-disable-next-line no-restricted-syntax
                        for(var _iterator1 = item.options[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var it = _step1.value;
                            if (values.includes(it.value)) finalArray.push(it.text);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                } else if (values.includes(item.value)) finalArray.push(item.text);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return finalArray;
    }), labels = _$ref2[0], setLabels = _$ref2[1];
    var _$ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
        var allOptions = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (item.type === "optgroup") {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        // eslint-disable-next-line no-restricted-syntax
                        for(var _iterator1 = item.options[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var it = _step1.value;
                            allOptions[it.value.toString()] = {
                                text: it.text,
                                value: it.value
                            };
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                } else allOptions[item.value.toString()] = {
                    text: item.text,
                    value: item.value
                };
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return allOptions;
    }), all = _$ref3[0], setAll = _$ref3[1];
    /** REFS */ var parentEl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    /** HANDLERS */ var handleOutsideClick = function(e) {
        if (e.target.closest(".".concat((_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sl))) !== parentEl.current) {
            setIsOpen(false);
            if (onClose) onClose();
        }
    };
    var handleOptionClick = function(v, t) {
        if (values.includes(v)) {
            setValues(multiple ? values.filter(function(a) {
                return a !== v;
            }) : []);
            setLabels(multiple ? labels.filter(function(a) {
                return a !== t;
            }) : []);
            if (onChange) onChange(multiple ? values.filter(function(a) {
                return a !== v;
            }) : []);
        } else {
            setValues(multiple ? values.concat([
                v
            ]) : [
                v
            ]);
            setLabels(multiple ? labels.concat([
                t
            ]) : [
                t
            ]);
            if (onChange) onChange(multiple ? values.concat([
                v
            ]) : [
                v
            ]);
            if (!multiple) setIsOpen(false);
        }
    };
    var handleGroupClick = function(v, t) {
        if (!multiple) return;
        /** If all items inside group already selected - deselect all. */ if (v.every(function(ai) {
            return values.includes(ai);
        })) {
            setValues(values.filter(function(a) {
                return !v.includes(a);
            }));
            setLabels(labels.filter(function(a) {
                return !t.includes(a);
            }));
            if (onChange) onChange(values.filter(function(a) {
                return !v.includes(a);
            }));
        } else {
            setValues(values.concat(v.filter(function(a) {
                return !values.includes(a);
            })));
            setLabels(labels.concat(t.filter(function(a) {
                return !labels.includes(a);
            })));
            if (onChange) onChange(values.concat(v.filter(function(a) {
                return !values.includes(a);
            })));
        }
    };
    var handleOptionMobileClick = function(e) {
        var selectedValues = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(e.target.options).filter(function(x) {
            return x.selected;
        });
        setValues(selectedValues.map(function(x) {
            return x.value;
        }));
        setLabels(selectedValues.map(function(x) {
            return x.innerText;
        }));
        if (onChange) onChange(selectedValues.map(function(x) {
            return x.value;
        }));
    };
    var handleSearchInput = function(e) {
        // eslint-disable-next-line no-unused-vars
        var inValue = e.target.value.toLowerCase();
        console.log(all);
    };
    var canDropdownDown = function() {
        var dropdownHeight = Object.keys(all).length * 50;
        var parentElPosition = parentEl.current.getBoundingClientRect();
        if (parentElPosition.top + parentElPosition.height + Math.min(dropdownHeight, 320) > window.innerHeight) return false;
        return true;
    };
    /** HOOKS */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.body.addEventListener("click", handleOutsideClick);
        return function() {
            return document.body.removeEventListener("click", handleOutsideClick);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var newValues = Array.isArray(selected) ? selected.map(function(v) {
            return v.toString();
        }) : [
            selected.toString()
        ];
        var labelsArray = [];
        var allOptions = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // eslint-disable-next-line no-restricted-syntax
            for(var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                if (item.type === "optgroup") {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        // eslint-disable-next-line no-restricted-syntax
                        for(var _iterator1 = item.options[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var it = _step1.value;
                            if (newValues.includes(it.value)) labelsArray.push(it.text);
                            allOptions[it.value.toString()] = it;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                } else if (newValues.includes(item.value)) {
                    labelsArray.push(item.text);
                } else {
                    allOptions[item.value.toString()] = item;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        setValues(newValues);
        setLabels(labelsArray);
        setAll(allOptions);
    }, [
        selected,
        options
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, function() {
        return {
            get: function get() {
                return values;
            },
            set: function set(x) {
                var inValues = Array.isArray(x) ? x.map(function(v) {
                    return v.toString();
                }) : [
                    x.toString()
                ];
                var availableOptions = Object.entries(all).filter(function(a) {
                    return inValues.includes(a[0]);
                });
                setValues(availableOptions.map(function(v) {
                    return v[1].value;
                }));
                setLabels(availableOptions.map(function(v) {
                    return v[1].text;
                }));
            }
        };
    });
    /** TEMPLATE */ if (!options.length || visibility === false) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().sl),
        ref: parentEl,
        style: style,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slTitle),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slContent),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slView),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                type: "button",
                                className: [
                                    (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slSelect),
                                    isOpen && (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().active)
                                ].filter(Boolean).join(" "),
                                onClick: function() {
                                    setIsOpen(!isOpen);
                                    if (onClose) onClose();
                                },
                                children: [
                                    isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", {
                                        className: (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slSelectHidden),
                                        multiple: multiple,
                                        value: values || [],
                                        onChange: handleOptionMobileClick,
                                        children: options.map(function(value, index) {
                                            if (value.type === "optgroup") {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("optgroup", {
                                                    label: value.text,
                                                    children: value.options.map(function(v, i) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                            value: v.value,
                                                            children: v.text
                                                        }, i);
                                                    })
                                                }, index);
                                            }
                                            if (value.type === "option") {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                    value: value.value,
                                                    children: value.text
                                                }, index);
                                            }
                                            return null;
                                        })
                                    }),
                                    placeholder && labels.length <= 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slSelectPlaceholder),
                                        children: placeholder
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slSelectLabels),
                                        children: labels.join(", ")
                                    })
                                ]
                            }),
                            !!values.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                title: "Очистить",
                                className: (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slReset),
                                onClick: function() {
                                    setValues([]);
                                    setLabels([]);
                                    if (onChange) onChange([]);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                                            x1: "18",
                                            y1: "6",
                                            x2: "6",
                                            y2: "18"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                                            x1: "6",
                                            y1: "6",
                                            x2: "18",
                                            y2: "18"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    isOpen && !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slDropdown),
                        style: !canDropdownDown() ? {
                            top: "auto",
                            bottom: "calc(100% + 2px)"
                        } : null,
                        children: [
                            search && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slDropdownSearch),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    placeholder: "Начните вводить поисковой запрос...",
                                    onInput: handleSearchInput
                                })
                            }),
                            options.map(function(value, index) {
                                if (value.type === "optgroup") {
                                    var valuesInsideGroup = value.options.map(function(v) {
                                        return v.value;
                                    });
                                    var labelsInsideGroup = value.options.map(function(v) {
                                        return v.text;
                                    });
                                    var allValuesSelected = valuesInsideGroup.every(function(ai) {
                                        return values.includes(ai);
                                    });
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                type: "button",
                                                className: [
                                                    (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slDropdownItem),
                                                    allValuesSelected && (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().active),
                                                    (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().big),
                                                    !multiple && value.options.length > 1 && (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled)
                                                ].filter(Boolean).join(" "),
                                                onClick: function() {
                                                    return handleGroupClick(valuesInsideGroup, labelsInsideGroup);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slDropdownItemCheckbox),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            children: allValuesSelected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                width: "20",
                                                                height: "20",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polyline", {
                                                                    points: "20 6 9 17 4 12"
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slDropdownItemText),
                                                        children: value.text
                                                    })
                                                ]
                                            }),
                                            value.options.map(function(v, i) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                    type: "button",
                                                    className: [
                                                        (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slDropdownItem),
                                                        (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().group),
                                                        values.includes(v.value) && (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().active)
                                                    ].filter(Boolean).join(" "),
                                                    onClick: function() {
                                                        return handleOptionClick(v.value.toString(), v.text);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slDropdownItemCheckbox),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                children: values.includes(v.value.toString()) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    width: "20",
                                                                    height: "20",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "2",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polyline", {
                                                                        points: "20 6 9 17 4 12"
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slDropdownItemText),
                                                            children: v.text
                                                        })
                                                    ]
                                                }, i);
                                            })
                                        ]
                                    }, index);
                                }
                                if (value.type === "option") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    type: "button",
                                    className: [
                                        (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slDropdownItem),
                                        values.includes(value.value) && (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().active)
                                    ].filter(Boolean).join(" "),
                                    onClick: function() {
                                        return handleOptionClick(value.value.toString(), value.text);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slDropdownItemCheckbox),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: values.includes(value.value.toString()) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "20",
                                                    height: "20",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polyline", {
                                                        points: "20 6 9 17 4 12"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_styles_modules_Select_module_scss__WEBPACK_IMPORTED_MODULE_2___default().slDropdownItemText),
                                            children: value.text
                                        })
                                    ]
                                }, index);
                                return null;
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
Select.displayName = "Select";
Select.defaultProps = {
    options: [],
    selected: [],
    visibility: true,
    placeholder: "Нажмите для выбора"
};
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 4545:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sl":"Select_sl__TawdZ","slTitle":"Select_slTitle__LXOp6","slContent":"Select_slContent__mkVQC","slView":"Select_slView__RICF8","slSelect":"Select_slSelect__DH_zm","slSelectPlaceholder":"Select_slSelectPlaceholder__4uJhz","slSelectLabels":"Select_slSelectLabels__ANzPi","active":"Select_active__JFm_Q","slSelectHidden":"Select_slSelectHidden__V1067","slReset":"Select_slReset__Y4HGY","slDropdown":"Select_slDropdown__TV4Ni","slDropdownSearch":"Select_slDropdownSearch__mCmeV","slDropdownItem":"Select_slDropdownItem__d5G_N","slDropdownItemCheckbox":"Select_slDropdownItemCheckbox__B1Y3P","slDropdownItemText":"Select_slDropdownItemText__CS4h0","disabled":"Select_disabled__ed16_","big":"Select_big__E7__A","group":"Select_group__gVs28"};

/***/ })

}]);